/**
 * Admin Dashboard View
 *
 * Tab container with 4 horizontal tabs:
 * 1. Year-over-Year (default) — KPI cards + grouped bar charts comparing billing across years
 * 2. Timekeeper Performance — Rolling performance table (week/month/year metrics per attorney)
 * 3. Utilization — Hourglass hours vs total billing hours per attorney (requires T&B sync)
 * 4. Hourglass Stats — Export/unexported/deleted hours, active users, high/low exporter breakdown
 */

import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "@/shared/components/ui/tabs";
import YearOverYearTab from "../components/dashboard/YearOverYearTab";
import TimekeeperPerformanceTab from "../components/dashboard/TimekeeperPerformanceTab";
import UtilizationTab from "../components/dashboard/UtilizationTab";
import HourglassStatsTab from "../components/dashboard/HourglassStatsTab";
import styles from "./AdminViews.module.css";

// Tab trigger styling — matches SettingsPanel pattern (bottom-border indicator)
const tabTriggerClass =
  "rounded-none border-b-2 border-transparent bg-transparent px-3 pb-2.5 pt-2 text-sm font-medium text-muted-foreground shadow-none transition-none data-[state=active]:border-b-primary data-[state=active]:bg-transparent data-[state=active]:text-foreground data-[state=active]:shadow-none";

export default function AdminDashboardView() {
  return (
    <div className={`${styles.adminViewWrapper} flex flex-col h-full`}>
      {/* Title */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-foreground">
          Admin Dashboard
        </h1>
        <p className="text-sm text-muted-foreground">
          Billing analytics and firm performance
        </p>
      </div>

      {/* Tabs */}
      <Tabs defaultValue="year-over-year" className="flex-1">
        <TabsList className="bg-transparent rounded-none border-b border-border w-full justify-start gap-2 p-0 h-auto">
          <TabsTrigger value="year-over-year" className={tabTriggerClass}>
            Year-over-Year
          </TabsTrigger>
          <TabsTrigger value="timekeeper-performance" className={tabTriggerClass}>
            Timekeeper Performance
          </TabsTrigger>
          <TabsTrigger value="utilization" className={tabTriggerClass}>
            Capture Rate
          </TabsTrigger>
          <TabsTrigger value="hourglass-stats" className={tabTriggerClass}>
            Hourglass Stats
          </TabsTrigger>
        </TabsList>

        <TabsContent value="year-over-year" className="mt-6">
          <YearOverYearTab />
        </TabsContent>

        <TabsContent value="timekeeper-performance" className="mt-6">
          <TimekeeperPerformanceTab />
        </TabsContent>

        <TabsContent value="utilization" className="mt-6">
          <UtilizationTab />
        </TabsContent>

        <TabsContent value="hourglass-stats" className="mt-6">
          <HourglassStatsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
